module.exports = __webpack_public_path__ + "img/web_sg_appeal_1.e569704a.jpg";